import { useEffect } from 'react';

import useSelectionValuesData from "helpers/context/SelectionValues/useSelectionValuesData";
import useSelectionValuesActions from "helpers/context/SelectionValues/useSelectionValuesActions";

function useSalespersons(parentCustomerID: string, parentSiteID: string) {

    const selectionValues = useSelectionValuesData();
    const actions = useSelectionValuesActions();
    const salespersons = selectionValues.salespersons;

    const isExpired = false;

    const cacheKey = `${parentCustomerID ?? ""}~|~${parentSiteID ?? ""}`;
    
    useEffect(() => {
        
        if (parentCustomerID && parentSiteID) {
            if (!salespersons.has(cacheKey) || isExpired)
            {
                actions.LoadSalespersonsAsync(parentCustomerID, parentSiteID, cacheKey);
            }
        }
        
    }, [actions, parentCustomerID, parentSiteID, salespersons, isExpired, cacheKey]);

    return salespersons.get(cacheKey);
}

export default useSalespersons;

